<style lang="less" scoped>
  .header {
    margin: 10px;
  }
  .content {
      p {
          margin: 10px 0;
      }
  }
  .group-contain {
      margin-bottom: 10px;
  }
  .people-app-contain {
    margin: 10px 0;
    display: flex;
    flex-direction:row ;
    .people {
        margin-right: 5px;
        flex: 1;
    }
    .app {
        margin-left: 5px;
        flex: 1;
    }
  }
  .item-button {
    margin-left: 5px;
    cursor: pointer;
  }
</style>
<template>
  <div>
    <Spin
      v-if="loading.getGroupCustomerLoading||loading.getAppListLoading"
      size="large"
      fix
    />
    <Card>
      <p slot="title">
        {{ groupDetail.name }}
      </p>
      <div class="content">
        <p>name：{{ groupDetail.name }}</p>
        <p>group_key：{{ groupDetail.group_key }}</p>
        <p>备注：{{ groupDetail.desc }}</p>
      </div>
    </Card>
    <div class="people-app-contain">
      <div class="people">
        <Card>
          <p slot="title">
            群组成员
          </p>
          <div>
            <Tag
              v-for="(item) in (groupDetail.customers ||[])"
              :key="item.id"
              style="margin: 10px 10px 0 0"
              size="medium"
            >
              {{ item.account }}
            </Tag>
            <Button
              style="margin: 10px 10px 0 0"
              icon="ios-remove-circle"
              type="dashed"
              size="small"
              @click="showModal(2)"
            >
              删除成员
            </Button>
            <Button
              style="margin: 10px 10px 0 0"
              icon="ios-add-circle"
              type="dashed"
              size="small"
              @click="showModal(1)"
            >
              添加成员
            </Button>
          </div>
        </Card>
      </div>
      <div class="app">
        <Card>
          <p slot="title">
            群组拥有app
          </p>
          <div>
            <Tag
              v-for="(item) in (appDetailList ||[])"
              :key="item.id"
              style="margin: 10px 10px 0 0"
              size="medium"
            >
              {{ item.name }}
              <span
                class="item-button"
                @click="editJurisdiction(item)"
              >
                <Icon
                  size="16"
                  type="ios-build"
                />
              </span>
            </Tag>
            <Button
              style="margin: 10px 10px 0 0"
              icon="ios-add-circle"
              type="dashed"
              size="small"
              @click="showModalJurisdiction(1)"
            >
              新增app权限
            </Button>
          </div>
        </Card>
      </div>
    </div>
    <EditPeople
      :display="showPeopleEdit"
      :selected-people="groupDetail.customers"
      @ok="submitEditPeople"
      @cancel="showModal(0)"
    />
    <EditJurisdiction
      :display="showGroupJurisdiction"
      :app-list="appList"
      :tree="tree"
      :get-app-list-loading="loading.getAppListLoading"
      :get-app-tree-loading="loading.getAppTreeLoading"
      :saving-loading="loading.updateMenuItemsLoading"
      :app-list-hash="appListHash"
      @projectChange="projectChange"
      @ok="submitJurisdictionData"
      @cancel="showModalJurisdiction(0)"
    />
  </div>
</template>
<script route="/router_manage/groupManage/detailEdit">
  import { GROUP_MANAGE } from '../constants'
  import { mapState, mapActions, mapMutations } from 'vuex'
  import EditPeople from '../components/EditPeople'
  import EditJurisdiction from '../components/EditJurisdiction'
  export default {
    components: { EditPeople, EditJurisdiction },
    data() {
      return {
        showPeopleEdit: 0, // 新增 1 删除 2
        showGroupJurisdiction: 0, // 新增 1 编辑 2 编辑
      }
    },
    computed: {
      ...mapState(GROUP_MANAGE, {
        loading:'loading',
        groupDetail: 'groupDetail',
        appList:'appList',
        tree:'tree',
        appDetailList:'appDetailList',
        selectedJurisdictionHash:'selectedJurisdictionHash',
        appListHash:'appListHash'
      }),
    },
    mounted() {
      this.id = this.$router.currentRoute.query.id
      this.getGroupCustomers({ id:this.id })
      this.getGroupAppList({ id:this.id })
    },
    destroyed() {
      this.detialEditDestryed()
    },
    methods: {
      ...mapActions(GROUP_MANAGE, [
        'getGroupCustomers',
        'addCustomers',
        'getAppRouterList',
        'getAppTree',
        'updateMenuItems',
        'getSelectItem',
        'getGroupAppList'
      ]),
      ...mapMutations(GROUP_MANAGE, ['setStateLevel0', 'detialEditDestryed']),
      // 编辑成员弹窗
      showModal(value) { this.showPeopleEdit = value },
      // 编辑app权限弹窗
      showModalJurisdiction(value) {
        switch (value) {
        case 0:
          this.setStateLevel0({key:'tree', value:[]})
          break;
        case 1:
          this.getAppRouterList()
          break;
        default:
          break;
        }
        this.showGroupJurisdiction = value
      },
      // 获取权限树
      projectChange(data) {
        this.getAppTree(data)
      },
      // 新增/修改权限树
      submitJurisdictionData(data) {
        const { route_menu_item_ids, route_app_id } = data
        const _this = this
        let params = {}
        if (this.showGroupJurisdiction === 1) {
          params = { route_app_id, id:this.id, add_item_ids:route_menu_item_ids, del_item_ids:[] }
        } else {
          const noIdHash = {}
          const add_item_ids = []
          const del_item_ids = []
          route_menu_item_ids.forEach(id => {
            if (!this.selectedJurisdictionHash[id]) {
              add_item_ids.push(id)
            } else {
              noIdHash[id] = true
            }
          });
          Object.keys(this.selectedJurisdictionHash).forEach(id => {
            if (!noIdHash[id]) {
              del_item_ids.push(Number(id))
            }
          })
          params = { route_app_id, add_item_ids, del_item_ids, id:this.id }
        }
        this.updateMenuItems({params,
                              callBack() {
                                _this.$Message.success(`${ _this.showGroupJurisdiction === 2 ? '编辑' : '新增'}成功`)
                                _this.showModalJurisdiction(0)
                                _this.getGroupAppList({ id:_this.id })
                              }
        })
      },
      editJurisdiction(data) {
        this.getSelectItem({
          id: this.id,
          route_app_id: data.id
        })
        this.showModalJurisdiction(2)
      },
      // 新增/修改人员
      submitEditPeople(type, value) {
        // type 1 表示添加 2 表示删除
        const _this = this
        this.addCustomers({
          params:{
            type,
            id:this.id,
            customer_ids:value
          },
          _this:this,
          callBack(type) {
            _this.showPeopleEdit = 0
            _this.$Message.success(type === 1 ? '新增组员成功！' : '删除组员成功！')
          }
        })
      }
    }
  }
</script>
